var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 256,
      height: 256,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4B4B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.193,103.525c15.995,0,28.964-12.97,28.964-28.973V28.964C178.157,12.97,165.188,0,149.193,0 c-16.002,0-28.973,12.97-28.973,28.964v45.588C120.22,90.556,133.191,103.525,149.193,103.525z",
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.816,103.525c15.994,0,28.964-12.97,28.964-28.973V28.964C391.78,12.97,378.81,0,362.816,0 c-16.003,0-28.973,12.97-28.973,28.964v45.588C333.843,90.556,346.813,103.525,362.816,103.525z",
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.164,41.287h-17.925v33.265c0,30.017-24.414,54.432-54.422,54.432c-30.018,0-54.432-24.415-54.432-54.432 V41.287H203.616v33.265c0,30.017-24.415,54.432-54.423,54.432c-30.016,0-54.432-24.415-54.432-54.432V41.287H76.836 c-38.528,0-69.763,31.235-69.763,69.763v331.187C7.073,480.765,38.309,512,76.836,512h358.328 c38.528,0,69.763-31.235,69.763-69.763V111.05C504.927,72.522,473.692,41.287,435.164,41.287z M470.982,442.237 c0,19.748-16.069,35.818-35.818,35.818H76.836c-19.748,0-35.818-16.07-35.818-35.818V155.138h429.964V442.237z",
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.862,
    y: 384.002,
    className: "st0",
    width: 62.859,
    height: 62.859,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.862,
    y: 286.584,
    className: "st0",
    width: 62.859,
    height: 62.859,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.453,
    y: 384.002,
    className: "st0",
    width: 62.851,
    height: 62.859,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.453,
    y: 286.584,
    className: "st0",
    width: 62.851,
    height: 62.859,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.697,
    y: 189.175,
    className: "st0",
    width: 62.851,
    height: 62.851,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.28,
    y: 189.175,
    className: "st0",
    width: 62.859,
    height: 62.851,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.28,
    y: 286.584,
    className: "st0",
    width: 62.859,
    height: 62.859,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.697,
    y: 384.002,
    className: "st0",
    width: 62.851,
    height: 62.859,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.697,
    y: 286.584,
    className: "st0",
    width: 62.851,
    height: 62.859,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.28,
    y: 384.002,
    className: "st0",
    width: 62.859,
    height: 62.859,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.862,
    y: 189.175,
    className: "st0",
    width: 62.859,
    height: 62.851,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.453,
    y: 189.175,
    className: "st0",
    width: 62.851,
    height: 62.851,
    style: {
      fill: "rgb(40, 40, 70)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.a467a205474118c57876d2837c31be37.svg";
export { ForwardRef as ReactComponent };